import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(LanguageDetector)
  .init({
    // we init with resources
    resources: {
      pl: {
        translations: {
          tournamentList: {
            title: 'Turnieje',
            register: 'Zarejestruj się',
            changeRegistration: 'Zmień rejestrację',
            confirmRegistration: 'Wyślij zgłoszenie',
            login: 'Zaloguj się',
            errors: {
              REGISTRATION_NOT_STARTED: 'Rejestracja jeszcze się nie rozpoczęła.',
              REGISTRATION_FULL: 'Limit rejestracji został przekroczony.',
              REGISTRATION_CLOSED: 'Rejestracja jest już zamknięta.',
              NO_ASSOCIATION_ID_OR_NAME: 'Nie podano imienia i nazwiska ani identyfikatora zawodnika.',
              PLAYERS_ALREADY_REGISTERED: 'Jeden z zawodników jest już zarejestrowany.',
              PLAYERS_NOT_FOUND: 'Nieprawidłowy identyfikator zawodnika w formularzu rejestracji.',
              REGISTRATION_REQUEST_INVALID: 'Nieprawidłowe dane w formularzu rejestracji.',
              MISSING_TEAM_NAME: 'Nie podano nazwy teamu.',
              BAD_REQUEST: 'Nieprawidłowe dane w formularzu.'
            }
          },
          registrationPage: {
            paymentStatus: {
              PENDING: 'Płatność jest w trakcie przetwarzania.',
              COMPLETED: 'Wpisowe zostało opłacone.'
            },
          }
        },
      },
    },
    fallbackLng: 'pl',
    debug: true,
    interpolation: {
      escapeValue: false,
    },
  });
 
export default i18n;



// WEBPACK FOOTER //
// ./i18n.js